export enum Temperature {
    Dry = "D",
    Refrigerated = "R",
    Frozen = "F",
    TemperatureSensitive = "T"
}